import React from 'react';
// Components
import StoreMarginsPage from '../../components/StoreMargins/StoreMarginsPage';

const ManageContentCreatorMargins: React.FC = () => {
  return (
    <StoreMarginsPage
      heading="Manage content creator store margins"
      description="Adjust platform fees for this content creator's store to override the default margins."
    />
  );
};

export default ManageContentCreatorMargins;
